<div cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
  @if (data) {
    <modal-header-default
      class="border"
			[options]="{
				headerTitle: data.title || (data.titleKey ? (data.titleKey | translate) : '---')
			}"></modal-header-default>
    <div content class="end-screen-content">
      <svg-inline
        class="end-screen-img"
        src="/assets/images/deposit/error.svg"
        [alt]="data.header || (data.headerKey ? (data.headerKey | translate) : '---')" />
      <div class="end-screen-headline">{{
        data.header || (data.headerKey ? (data.headerKey | translate) : "---")
      }}</div>
      <p class="end-screen-description">{{
        data.description || (data.descriptionKey ? (data.descriptionKey | translate) : "---")
      }}</p>
      <div class="end-screen-buttons-container">
        @if (!data.hidePrimaryButton) {
          <button type="button" class="btn btn-link" (click)="primary()">{{
            data.primaryButton || (data.primaryButtonKey ? (data.primaryButtonKey | translate) : "---")
          }}</button>
        }
        @if (!data.hideSecondaryButton) {
          <button
            type="button"
            class="btn btn-primary mod-button-width btn-bold"
            (click)="secondary()"
            >
            {{
            data.secondaryButton ||
            (data.secondaryButtonKey ? (data.secondaryButtonKey | translate) : "---")
            }}
          </button>
        }
      </div>
    </div>
  }
</div>
